export const federatedAppData = {
    local: {
      commonHeader: {
        url: "http://localhost:8093",
        scope: "fecommonapps",
        module: "./CommonHeader",
        remoteEntryFileName: "commonAppsContainer.js",
      },
      commonNavigation: {
        url: "http://localhost:8093",
        scope: "fecommonapps",
        module: "./CommonNavigation",
        remoteEntryFileName: "commonAppsContainer.js",
      },
    },
    staging: {
      commonHeader: {
        url: "https://fe-common-apps.51b.dev",
        scope: "fecommonapps",
        module: "./CommonHeader",
        remoteEntryFileName: "commonAppsContainer.js",
      },
      commonNavigation: {
        url: "https://fe-common-apps.51b.dev",
        scope: "fecommonapps",
        module: "./CommonNavigation",
        remoteEntryFileName: "commonAppsContainer.js",
      },
    },
    production: {
      commonHeader: {
        url: "https://fe-common-apps.brevo.com",
        scope: "fecommonapps",
        module: "./CommonHeader",
        remoteEntryFileName: "commonAppsContainer.js",
      },
      commonNavigation: {
        url: "https://fe-common-apps.brevo.com",
        scope: "fecommonapps",
        module: "./CommonNavigation",
        remoteEntryFileName: "commonAppsContainer.js",
      },
    },
  };